class Slideshow {
  constructor(section) {
    this.section = section;
    this.box = section.querySelector('.slideshow-wrap');
    this.id = section.id;
    this.swiper = null;
  }

  initialize() {
    if (!this.box) return;
    if (this.section.classList.contains('slideshow_started')) return;
    this.section.classList.add('slideshow_started');

    const { autoplay, stopAutoplay, delay, speed, autoHeight, paginationStyle } = this.box.dataset;
    const autoplayEnabled = autoplay === 'true';
    const stopAutoplayEnabled = stopAutoplay === 'true';
    const autoHeightEnabled = autoHeight === 'true';

    const slides = this.section.querySelectorAll('.swiper-slide');
    const hasEnoughSlides = slides.length > 1;

    const autoplayParam = autoplayEnabled && hasEnoughSlides
      ? {
        autoplay: {
          delay: parseFloat(delay) * 1000,
          pauseOnMouseEnter: stopAutoplayEnabled,
          disableOnInteraction: false,
          waitForTransition: true,
        },
      }
      : {};

    const swiperParams = {
      speed: parseFloat(speed) * 1000,
      loop: hasEnoughSlides,
      centeredSlides: false,
      keyboard: true,
      autoHeight: autoHeightEnabled,
      pagination: {
        el: this.section.querySelector('.slideshow-pagination'),
        clickable: true,
        dynamicBullets: false,
        enabled: hasEnoughSlides,
        renderBullet: function (index, className) {
          if (paginationStyle !== 'icon') {
            return `<span class="${className}"></span>`;
          }
          const bulletNumber = index + 1;
          const slide = slides[index];
          const dotColor = slide ? slide.dataset.dotColor : '';
          const style = dotColor ? `style="color: ${dotColor}"` : '';

          return `<span class="${className} swiper-pagination-bullet-${bulletNumber}" ${style}>
            <svg fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 30 30" xml:space="preserve">
              <g id="button-2">
                <path d="M15,0C6.716,0,0,6.716,0,15s6.716,15,15,15s15-6.716,15-15S23.284,0,15,0z M15,27C8.383,27,3,21.617,3,15S8.383,3,15,3 s12,5.383,12,12S21.617,27,15,27z"></path>
                <path d="M15,4.938C9.442,4.938,4.938,9.441,4.938,15c0,5.558,4.505,10.063,10.063,10.063S25.063,20.558,25.063,15 S20.558,4.938,15,4.938z M10.998,20.983c-1.092,0-1.976-0.885-1.976-1.976s0.884-1.976,1.976-1.976 c1.091,0,1.977,0.885,1.977,1.976S12.089,20.983,10.998,20.983z M10.998,13.015c-1.092,0-1.976-0.885-1.976-1.976 s0.884-1.976,1.976-1.976c1.091,0,1.977,0.885,1.977,1.976S12.089,13.015,10.998,13.015z M19.01,20.983 c-1.092,0-1.976-0.885-1.976-1.976s0.884-1.976,1.976-1.976c1.091,0,1.977,0.885,1.977,1.976S20.101,20.983,19.01,20.983z M19.01,13.015c-1.092,0-1.976-0.885-1.976-1.976s0.884-1.976,1.976-1.976c1.091,0,1.977,0.885,1.977,1.976 S20.101,13.015,19.01,13.015z"></path>
              </g>
            </svg>
          </span>`;
        }
      },
      navigation: {
        prevEl: this.section.querySelector('.slideshow-arrow-prev'),
        nextEl: this.section.querySelector('.slideshow-arrow-next'),
        enabled: hasEnoughSlides
      },
      init: false,
      ...autoplayParam,
    };

    if (!hasEnoughSlides) {
      const prevButton = this.section.querySelector('.slideshow-arrow-prev');
      const nextButton = this.section.querySelector('.slideshow-arrow-next');
      const pagination = this.section.querySelector('.slideshow-pagination');

      if (prevButton) prevButton.style.display = 'none';
      if (nextButton) nextButton.style.display = 'none';
      if (pagination) pagination.style.display = 'none';
    }

    if (!this.swiper && typeof Swiper !== 'undefined') {
      const swiperEl = this.section.querySelector('.slideshow');
      if (swiperEl) {
        const isFirstSlide = this.section.closest('.shopify-section')?.previousElementSibling === null ||
          this.section.getBoundingClientRect().top < window.innerHeight;

        const runInitLogic = (swiperInstance) => {
          this.swiper = swiperInstance;
          if (!this.swiper) return;

          setTimeout(() => {
            if (this.swiper && this.swiper.pagination) {
              this.swiper.pagination.update();
              this.swiper.pagination.render();
            }
            this.swiper.update();
          }, 100);

          if (this.swiper.initialized) {
          } else {
            this.swiper.init();
          }
        };

        Kinderly.Swiper.init(swiperEl, {
          ...swiperParams,
          immediate: isFirstSlide,
          onInit: (swiperInstance) => runInitLogic(swiperInstance)
        });
      }
    } else if (this.swiper) {
      this.swiper.params.autoplay = autoplayEnabled && hasEnoughSlides ? swiperParams.autoplay : false;
      this.swiper.params.loop = hasEnoughSlides;
      this.swiper.params.pagination.enabled = hasEnoughSlides;
      this.swiper.params.navigation.enabled = hasEnoughSlides;
      this.swiper.update();
    }
  }

  updatePagination() {
    if (this.swiper && this.swiper.pagination) {
      this.swiper.update();
      this.swiper.pagination.update();
    }
  }
}

const initSlideshows = (retryCount = 0) => {
  if (typeof Swiper === 'undefined' || typeof Kinderly === 'undefined' || !Kinderly.Swiper) {
    if (retryCount < 15) {
      setTimeout(() => initSlideshows(retryCount + 1), 200);
    }
    return;
  }

  document.querySelectorAll('.slideshow-section').forEach((section) => {
    requestAnimationFrame(() => {
      const slideshow = new Slideshow(section);
      slideshow.initialize();
    });
  });
};

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initSlideshows());
} else {
  setTimeout(initSlideshows, 500);
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.slideshow-section') || (event.target.classList.contains('slideshow-section') ? event.target : null);
  if (section) {
    section.classList.remove('slideshow_started');
    const slideshow = new Slideshow(section);
    slideshow.initialize();
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector('.slideshow-section') || (event.target.classList.contains('slideshow-section') ? event.target : null);
  if (section) {
    const swiperEl = section.querySelector('.slideshow');
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
  }
});
window.Slideshow = Slideshow;
